import styled from 'styled-components'

import { Input as InputComponent } from 'primsell-shared-layer/components'

export const Input = styled(InputComponent)`
  width: 264px;
`

export const CopyContainer = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: #eaeaea;
  margin-top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`

export const CopyIconStyled = styled.div`
  background: none;
`
